import { request } from "./api-require";
const API_URL = "/oms-pay-service/v1";
/**
 *  收入分析 获取统计数据数据
 * @param data
 * @param config
 * @returns
 */
export const getMerchantStatistics = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/pay/order/settlement/merchant/statics", data, config);
};
/**
 *  收入分析 获取统计数据图表
 * @param data
 * @param config
 * @returns
 */
export const getMerchantStatisticsListDate = (data = {}, config = {}) => {
    return request(API_URL + "/pay/order/settlement/merchant/static/list/date", data, config);
};
